import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup,  Validators } from '@angular/forms';
import { ActivatedRoute, Router} from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, MonedaService, PaisService, ProveedorService, ActividadPrincipalService, BancoService, TipoDocumentoService, IncidenciaUsuarioService, GastoService, TenantService, CuentaService, MovimientoService } from '../../../../src/app/shared/services';
import { Proveedor, MenuFuncionCodes, SaveProveedorDto, SearchPaisRequest, Pais, Provincia, DialogConfirmRequest, DialogConfirmResponse, SearchMonedaRequest, Moneda, Banco, SearchBancoRequest, SearchTipoDocumentoRequest, TipoDocumento, SearchCuentaRequest, Cuenta, GetSaldoRequestDto, GetSaldoMonedaDto,
  DialogPersonaSearchComponentRequestDto, DialogPersonaSearchComponentResponseDto, Persona, IncidenciaUsuario, SearchIncidenciaUsuarioRequestDto, Gasto, SearchGastoRequest, ActividadPrincipal, SearchActividadPrincipalRequest,
  ReporteProductividadDto, LocalStorageKeys, TenantFeatureFlags
 } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { DialogPersonaSearchComponent } from '../usuarios/components/dialogPersonaSearch.component';

@Component({
  selector: 'app-proveedores-edit',
  templateUrl: './proveedores-edit.component.html',
  styleUrls: ['./proveedores-edit.component.scss']
})
export class ProveedoresEditComponent implements OnInit {
  formGroup: FormGroup;
  contacto1FormGroup: FormGroup;
  contacto2FormGroup: FormGroup;
  cuentaBancariaFormGroup: FormGroup;

  @ViewChild('cuentasGrid')
  public cuentasGrid: GridComponent;

  isMonedaSearching: boolean = false;
  isBancoSearching: boolean = false;
  isValidating: boolean = false;
  isSearching: boolean = false;
  isPaisSearching: boolean = false;
  isActividadSearching: boolean = false;
  isProvinciaSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isTipoDocumentoSearching: boolean = false;
  isIncidenciasSearching: boolean = false;
  isGastosSearching: boolean = false;
  isReporteProductividadSearching: boolean = false;
  isSaldosSearching: boolean = false;
  isCuentasSearching: boolean = false;

  canEdit: boolean = false;
  canDelete: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;
  canEditCuenta: boolean = false;
  canDeleteCuenta: boolean = false;
  canAddCuenta: boolean = false;
  canViewCuenta: boolean = false;
  canViewIncidencias: boolean = false;
  canViewGastos: boolean = false;
  canViewSaldos: boolean = false;
  canViewPersonDetail: boolean = false;

  tenantFeatureFlags: TenantFeatureFlags;

  msgError: string = "";
  msgPaisError: string = "";
  msgActividadError: string = "";
  msgProvinciaError: string = "";
  msgBancoError: string = "";
  item: Proveedor;
  itemCuentaList: Cuenta[];

  incidenciasList: IncidenciaUsuario[];
  gastosList: Gasto[];
  proveedorProductividad: ReporteProductividadDto;

  paisesList: Pais[] = [];
  actividadList: ActividadPrincipal[] = [];
  provinciaList: Provincia[] = [];
  monedaList: Moneda[] = [];
  bancoList: Banco[] = [];
  tipoDocumentoList: TipoDocumento[] = [];
  saldosList: GetSaldoMonedaDto[];

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor (
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private router: Router,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private monedaService: MonedaService,
    private bancoService: BancoService,
    private paisService: PaisService,
    private actividadPrincipalService: ActividadPrincipalService,
    private tipoDocumentoService: TipoDocumentoService,
    private incidenciaUsuarioService: IncidenciaUsuarioService,
    private gastoService: GastoService,
    private cuentaService: CuentaService,
    private movimientoService: MovimientoService,
    private tenantService: TenantService,
    private proveedorService: ProveedorService) {
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.PROVEEDOR).subscribe(data => {

      if (data.Result.some(x => x == MenuFuncionCodes.PROVEEDOR_LIST)) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canEdit = data.Result.some(x => x == MenuFuncionCodes.PROVEEDOR_EDIT);
            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.PROVEEDOR_ADD);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.PROVEEDOR_LIST);
            this.canDelete = data.Result.some(x => x == MenuFuncionCodes.PROVEEDOR_DELETE);

            this.loadView();
          }
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.isValidating = false;
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();
    this.buildContacto1Form();
    this.buildContacto2Form();
    this.buildCuentaForm();

    this.puedeVerCuentas();
    this.puedeVerIncidencias();
    this.puedeVerGastos();
    this.puedeVerSaldos();

    this.loadEntity();
    this.getTiposDocumento();
    this.getPaises();
    this.getActividad();
    this.getMonedas();
    this.getBancos();

    this.menuService.checkMenuPadre(MenuFuncionCodes.PERSONA).subscribe(data => {
      if (data != null && data.Success) {
        this.canViewPersonDetail = data.Result != null && data.Result.length > 0;
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  puedeVerCuentas() {
    this.menuService.checkMenuPadre(MenuFuncionCodes.CUENTA).subscribe(data => {
      if (data != null && data.Success && data.Result != null)
        this.canEditCuenta = data.Result.some(x => x == MenuFuncionCodes.CUENTA_EDIT);
        this.canAddCuenta = data.Result.some(x => x == MenuFuncionCodes.CUENTA_ADD);
        this.canViewCuenta = data.Result.some(x => x == MenuFuncionCodes.CUENTA_LIST);
        this.canDeleteCuenta = data.Result.some(x => x == MenuFuncionCodes.CUENTA_DELETE);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  puedeVerIncidencias() {
    this.menuService.checkMenuPadre(MenuFuncionCodes.INCIDENCIA_USUARIO).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewIncidencias = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_LIST) ||
            data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_LIST_BO);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  puedeVerGastos() {
    this.menuService.checkMenu(MenuFuncionCodes.GASTO_LIST).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewGastos = true;
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  puedeVerSaldos() {
    if (!this.tenantFeatureFlags?.HabilitarControlCaja) {
      this.canViewSaldos = false;
      return false;
    }

    this.menuService.checkMenuPadre(MenuFuncionCodes.MOVIMIENTO).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewSaldos = this.canViewSaldos || (data?.Result != null && data?.Result.length > 0);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'RazonSocial': [null, [Validators.required, Validators.maxLength(150)]],
      'Codigo': [null, Validators.maxLength(100)],
      'Domicilio': [null, Validators.maxLength(150)],
      'LocalidadBarrio': [null, Validators.maxLength(100)],
      'CodigoPostal': [null, Validators.maxLength(50)],
      'Cuit': [null, Validators.required],
      'PaisId': [null],
      'ActividadPrincipalId': [null],
      'Observacion': [null, Validators.maxLength(300)],
      'Activo': [true, Validators.required]
    });
  }

  buildCuentaForm() {
    this.cuentaBancariaFormGroup = this.formBuilder.group({
      'Id': [0],
      'BancoId': [null, Validators.required],
      'MonedaId': [null, Validators.required],
      'ClaveBancaria': [null, [Validators.required, Validators.maxLength(100)]],
      'Alias': [null, [Validators.required, Validators.maxLength(100)]],
      'Titular': [null, [Validators.maxLength(100)]],
      'NumeroCuenta': [null, [Validators.maxLength(100)]],
      'Activo': [true],
      'grid-index': [null]
    });
  }

  buildContacto1Form() {
    this.contacto1FormGroup = this.formBuilder.group({
      'Id': [0],
      'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
      'Apellido': [null, [Validators.required, Validators.maxLength(150)]],
      'TipoDocumentoId': [null],
      'NroDocumento': [null],
      'Cuit': [null, Validators.maxLength(100)],
      'MovilContacto': [null, Validators.maxLength(100)],
      'MovilContactoOtro': [null, Validators.maxLength(100)],
      'MailContacto': [null, [Validators.maxLength(255), Validators.email]],
      'Activo': [true]
    });
  }

  buildContacto2Form() {
    this.contacto2FormGroup = this.formBuilder.group({
      'Id': [0],
      'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
      'Apellido': [null, [Validators.required, Validators.maxLength(150)]],
      'TipoDocumentoId': [null],
      'NroDocumento': [null],
      'Cuit': [null, Validators.maxLength(100)],
      'MovilContacto': [null, Validators.maxLength(100)],
      'MovilContactoOtro': [null, Validators.maxLength(100)],
      'MailContacto': [null, [Validators.maxLength(255), Validators.email]],
      'Activo': [true]
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
          if (this.canView || this.canEdit) {
            this.isSearching = true;
            this.proveedorService.get(id).subscribe(data => {
            this.isSearching = false;

            if (data != null && data.Success) {
              this.item = data.Result;
              // console.log(this.item)

              if (this.item != null && this.item.Id > 0) {
                this.getCuentas(this.item.Id);
                this.getIncidencias(this.item.Id);
                this.getGastos(this.item.Id);

                this.getReporteProductividad(this.item.Id);
                this.getSaldos(this.item.Id);

                this.formGroup.patchValue(this.item);

                if (this.item.PersonaContacto != null)
                  this.contacto1FormGroup.patchValue(this.item.PersonaContacto);

                if (this.item.PersonaContactoOpcional != null)
                  this.contacto2FormGroup.patchValue(this.item.PersonaContactoOpcional);

                if (this.item.Cuentas != null)
                  this.cuentaBancariaFormGroup.patchValue(this.item.Cuentas);
              }
              else
                this.msgError = "No se encontró el item seleccionado.";
            }
            else
            this.msgError = "Ocurrió un error al intentar obtener los datos del item.";
          },
          (err: HttpErrorResponse) => {
            this.isSearching = false;
            this.sharedFunctions.handleError(err, true);
          })
          }
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
            }
        }
        else
          this.msgError = "Item no válido.";
      }
      else {
        if (this.canAdd) {
          this.item = new Proveedor(0, null, null,null,null,null,null,null,null,null,null,null,true,null,null,null,null, []);
          this.formGroup.patchValue(this.item);
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel();
        }
      }
    });
  }

  getMonedas() {
    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
        this.isMonedaSearching = false;
        this.monedaList = data?.result;
    },
    (err: HttpErrorResponse) => {
        this.isMonedaSearching = false;
        this.sharedFunctions.handleError(err);
    });
  }

  getReporteProductividad(id: number) {
    this.isReporteProductividadSearching = true;
    this.proveedorService.getReporteProductividad(id).subscribe(data => {
      this.isReporteProductividadSearching = false;
      if (data != null && data.Success)
        this.proveedorProductividad = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isReporteProductividadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getCuentas(id: number) {
    var r = new SearchCuentaRequest(null, null, true, "Alias", null, null, null, null, null, null, null, id, null, null, null, null, true, null, null, null);
    this.isCuentasSearching = true;

    this.cuentaService.search(r).subscribe(data => {
      this.isCuentasSearching = false;
      // console.log(data);
      if (this.item != null)
        this.item.Cuentas = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isCuentasSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getSaldos(id) {
    var r = new GetSaldoRequestDto(null, null, null, null, id, null, null);
    this.isSaldosSearching = true;

    this.movimientoService.getSaldo(r).subscribe(data => {
      this.isSaldosSearching = false;
      if (data?.Success)
        this.saldosList = data.Result?.Saldos;
    },
    (err: HttpErrorResponse) => {
      this.isSaldosSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getIncidencias(id: number) {
    var r = new SearchIncidenciaUsuarioRequestDto(null, null, true, "FechaUltimoMensaje", null, null, null, null, null, null, null, id, null, null, null, null, null, null, null, null);
    this.isIncidenciasSearching = true;

    this.incidenciaUsuarioService.search(r).subscribe(data => {
      this.isIncidenciasSearching = false;
      this.incidenciasList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isIncidenciasSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getGastos(id: number) {
    var r = new SearchGastoRequest(null, null, false, "FechaGasto", null, null, null, id, null, null, null, null, null, null, null, null, null, null, true);
    this.isGastosSearching = true;

    this.gastoService.search(r).subscribe(data => {
      this.isGastosSearching = false;
      this.gastosList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isGastosSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getBancos() {
    this.bancoService.search(new SearchBancoRequest(null,null,null,null,null,null,null,true)).subscribe(data => {
      this.isBancoSearching = true;
      if (data != null && data.result) {
        this.isBancoSearching = false;
        this.bancoList = data?.result;
      }
      else
        this.msgBancoError = "Ocurrió un error al intentar obtener los datos de banco.";
    },
    (err: HttpErrorResponse) => {
      this.isBancoSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  getActividad() {

    this.actividadPrincipalService.search(new SearchActividadPrincipalRequest(null,null,null,null,null,null,true)).subscribe(data => {
      this.isActividadSearching = false;
      if (data != null && data.result) {
        this.actividadList = data?.result;
        if (this.item != null && this.item.Id > 0) {
          this.formGroup.patchValue(this.item);
        }
      }else
      this.msgPaisError = "Ocurrió un error al intentar obtener los datos de Actividad Principal.";
    },
    (err: HttpErrorResponse) => {
      this.isActividadSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getPaises() {
    this.paisService.search(new SearchPaisRequest(null,null,null,null,null,null,true)).subscribe(data => {
      this.isPaisSearching = false;
      if (data != null && data.result) {
        this.paisesList = data.result;
        if (this.item != null && this.item.Id > 0) {
          this.formGroup.patchValue(this.item);
        }

      }
      else
        this.msgPaisError = "Ocurrió un error al intentar obtener los datos de pais.";
    },
    (err: HttpErrorResponse) => {
      this.isPaisSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  getTiposDocumento() {
    var r = new SearchTipoDocumentoRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoDocumentoSearching = true;

    this.tipoDocumentoService.search(r).subscribe(data => {
      this.isTipoDocumentoSearching = false;
      if (data != null) {
        this.tipoDocumentoList = data?.result;
      }
    },
    (err: HttpErrorResponse) => {
      this.isTipoDocumentoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  editGasto(item: any) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (!this.canViewGastos)
      return false;

    this.router.navigate(['gasto-edit', item.Id]);
  }

  onGuardar() {
    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new SaveProveedorDto(0, null, null, null, null, null, null, null, null, null, true, null, null, null, null, []);
    r =
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.item?.Id ?? 0),
        PersonaContactoId: this.item?.PersonaContactoId,
        PersonaContactoOpcionalId: this.item?.PersonaContactoOpcionalId,
        PersonaContacto: this.contacto1FormGroup.value,
        PersonaContactoOpcional: this.contacto2FormGroup.value,
        Activo: (this.item?.Activo ?? true),
        Cuentas: this.item?.Cuentas
      }
    };

    this.isSaving = true;
    this.proveedorService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCuentaSave() {
    if (this.cuentaBancariaFormGroup.invalid) {
      this.sharedFunctions.showMessage("Formulario inválido. Por favor, complete todos los campos requeridos.", "Error");
      return;
    }

    var nuevaCuenta = new Cuenta(0, null, false, null, null, null, null, null, null, null, null, true, null, null, null, null, null, null, null, null, null, null);
    nuevaCuenta = {
      ...this.cuentaBancariaFormGroup.getRawValue(),
      BancoNombre: this.bancoList.find(x => x.Id == this.cuentaBancariaFormGroup.get("BancoId")?.value)?.Nombre,
      MonedaCodigo: this.monedaList.find(x => x.Id == this.cuentaBancariaFormGroup.get("MonedaId")?.value)?.Codigo,
      ProveedorId: (this.item?.Id ?? 0)
    };

    // console.log(nuevaCuenta);

    if (this.item.Cuentas == null)
      this.item.Cuentas = [];

    var index = this.cuentaBancariaFormGroup.get("grid-index")?.value;
    // console.log(index);
    if (index != null && index >= 0) {
      // console.log("lala");
      this.item.Cuentas[index] = nuevaCuenta;
    }
    else {
      // console.log("adsdsa");
      var exists = this.item.Cuentas.some(f => f.Alias == nuevaCuenta.Alias || f.ClaveBancaria == nuevaCuenta.ClaveBancaria);
      if (exists) {
        this.sharedFunctions.showMessage("El alias o CBU/CVU ingresados ya existen para el proveedor", "Error");
        return false;
      }

      this.item.Cuentas.push(nuevaCuenta);
    }

    this.cuentaBancariaFormGroup.reset();
    this.cuentaBancariaFormGroup.controls['Id'].setValue(0);
    this.cuentaBancariaFormGroup.controls['Activo'].setValue(true);

    // console.log(this.item.Cuentas);
    this.cuentasGrid?.refresh();
  }

  onCuentaView(data: any) {
    this.cuentaBancariaFormGroup.patchValue(data);
    this.cuentaBancariaFormGroup.get("grid-index")?.setValue(data.index);
  }

  onCuentaDelete(data: any) {
    if (this.item.Cuentas == null)
      this.item.Cuentas = [];

    if (data.index >= 0) {
      this.item.Cuentas.splice(data.index, 1);
      this.cuentasGrid?.refresh();
    }
  }

  onDelete() {
    if (!this.canDelete)
        return false;

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar el proveedor?", null, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isDeleting = true;
        this.proveedorService.delete(this.item.Id).subscribe(data => {
          this.isDeleting = false;
          if (data != null && data.Success && data.Result) {
            this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
            this.onCancel();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
            this.isDeleting = false;
            this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }

  viewIncidencia(id: number) {
    if (id == null || id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un incidente para continuar", "Error");
      return false;
    }

    this.router.navigate(['incidencia-usuario-edit', id]);
  }

  onCancel() {
    this.location.back();
  }

  onContacto1SearchClick() {
    if (this.isProcessing())
      return;

    const dialogRef = this.dialog.open(DialogPersonaSearchComponent, {
        width: '90%',
        data: new DialogPersonaSearchComponentRequestDto(false, 0)
    });

    dialogRef.afterClosed().subscribe((result: DialogPersonaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {
        var u = (result.Items != null && result.Items.length > 0 ? result.Items[0] : null);

        if (this.item != null && u != null) {
          this.item.PersonaContactoId = u?.Id;
          this.item.PersonaContacto = u;
        }

        if (this.item.PersonaContacto)
        this.contacto1FormGroup.patchValue(this.item.PersonaContacto);
      }
    });
  }

  onContacto1DeassociateClick() {
    this.item.PersonaContacto = new Persona(0, null, null, null, null, null, null, null,null, null, true, null, null, null);
    if (this.canAdd || this.canEdit) {
      this.item.PersonaContactoId = null;
      this.contacto1FormGroup.patchValue(this.item.PersonaContacto);
    }
  }

  canDeassociateContacto1() {
    if(this.item.PersonaContactoId)
    return (this.canAdd || this.canEdit) && this.item != null && this.item.PersonaContactoId > 0;
  }

  onContacto2SearchClick() {
    if (this.isProcessing())
      return;

    const dialogRef = this.dialog.open(DialogPersonaSearchComponent, {
        width: '90%',
        data: new DialogPersonaSearchComponentRequestDto(false, 0)
    });

    dialogRef.afterClosed().subscribe((result: DialogPersonaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {
        var u = (result.Items != null && result.Items.length > 0 ? result.Items[0] : null);

        if (this.item != null && u !== null) {
          this.item.PersonaContactoOpcionalId = u?.Id;
          this.item.PersonaContactoOpcional = u;
        }
        if(this.item.PersonaContactoOpcional)
          this.contacto2FormGroup.patchValue(this.item.PersonaContactoOpcional);
      }
    });
  }

  onContacto2DeassociateClick() {
    this.item.PersonaContactoOpcional = new Persona(0, null, null, null, null, null, null,null, null, null, true, null, null, null);
    if (this.canAdd || this.canEdit) {
      this.item.PersonaContactoOpcionalId = 0;
      this.contacto2FormGroup.patchValue(this.item.PersonaContactoOpcional);
    }
  }

  canDeassociateContacto2() {
    if (this.item.PersonaContactoOpcionalId)
    return (this.canAdd || this.canEdit) && this.item != null && this.item.PersonaContactoOpcionalId > 0;
  }

//#region  error messages
  getErrorCuit() {
    var v = this.formGroup.get('Cuit');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorCodigo() {
    var v = this.formGroup.get('Codigo');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorRazonSocial() {
    var v = this.formGroup.get('RazonSocial');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorDomicilio() {
    var v = this.formGroup.get('Domicilio');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 1500 caracteres alcanzado';
    return '';
  }

  getErrorPais() {
    return this.formGroup.get('PaisId')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorLocalidadBarrio() {
    var v = this.formGroup.get('LocalidadBarrio');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorCodigoPostal() {
    var v = this.formGroup.get('CodigoPostal');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 50 caracteres alcanzado';
    return '';
  }

  getErrorObservacion() {
    var v = this.formGroup.get('Observacion');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  getErrorAlias() {
    var v = this.cuentaBancariaFormGroup.get('Alias');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }

  getErrorClaveBancaria() {
    var v = this.cuentaBancariaFormGroup.get('ClaveBancaria');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }

  getErrorNumeroCuenta() {
    var v = this.cuentaBancariaFormGroup.get('NumeroCuenta');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorTitular() {
    var v = this.cuentaBancariaFormGroup.get('Titular');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMoneda() {
    var v = this.cuentaBancariaFormGroup.get('MonedaId');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorBanco() {
    var v = this.cuentaBancariaFormGroup.get('BancoId');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorNombre1() {
    var v = this.contacto1FormGroup.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorApellido1() {
    var v = this.contacto1FormGroup.get('Apellido');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErroMailContacto1() {
    var v = this.contacto1FormGroup.get('MailContacto');
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    if (v?.hasError('email'))
      return 'Debe ingresar un email con formato válido';
    return '';
  }

  getErrorMovilContacto1() {
    var v = this.contacto1FormGroup.get('MovilContacto');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    else if(v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErroMovilContactoOtro1() {
    var v = this.contacto1FormGroup.get('MovilContactoOtro');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorTipoDocumentoId1() {
    return this.contacto1FormGroup.get('TipoDocumentoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorNroDocumento1() {
    var v = this.contacto1FormGroup.get('NroDocumento');
    if(v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorNombre2() {
    var v = this.contacto2FormGroup.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorApellido2() {
    var v = this.contacto2FormGroup.get('Apellido');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErroMailContacto2() {
    var v = this.contacto2FormGroup.get('MailContacto');
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    if (v?.hasError('email'))
      return 'Debe ingresar un email con formato válido';
    return '';
  }

  getErrorMovilContacto2() {
    var v = this.contacto2FormGroup.get('MovilContacto');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    else if(v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErroMovilContactoOtro2() {
    var v = this.contacto2FormGroup.get('MovilContactoOtro');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorTipoDocumentoId2() {
    return this.contacto2FormGroup.get('TipoDocumentoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorNroDocumento2() {
    var v = this.contacto2FormGroup.get('NroDocumento');
    if(v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  //#endregion

  viewPersona(id: number) {
    if (id == null || id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (!this.canViewPersonDetail)
      return false;

    this.router.navigate(['persona-edit', id]);
  }
}
